export default __webpack_public_path__ + "static/media/home_icon.f007cf28.svg";